import { render, staticRenderFns } from "./chooseSalonDialog.vue?vue&type=template&id=9b7a3436&scoped=true"
import script from "./chooseSalonDialog.vue?vue&type=script&lang=js"
export * from "./chooseSalonDialog.vue?vue&type=script&lang=js"
import style0 from "./chooseSalonDialog.vue?vue&type=style&index=0&id=9b7a3436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b7a3436",
  null
  
)

export default component.exports